export default "<p>temporary-manual-rostering works!</p>\r\n";